class SeeMore {
    constructor(defaultWordLimit = 20) {
        this.defaultWordLimit = defaultWordLimit;
        this.init();
    }

    init() {
        const elements = document.querySelectorAll('.see-more');
        elements.forEach(el => {
            if (el.dataset.seeMoreInitialized) return;
            el.dataset.seeMoreInitialized = true;

            const limit = parseInt(el.dataset.wordLimit) || this.defaultWordLimit;
            const fullText = el.textContent.trim();
            const words = fullText.split(/\s+/);
            if (words.length <= limit) return;

            const shortText = words.slice(0, limit).join(' ');

            el.innerHTML = `
                <span class="see-more-content">
                    <span class="see-more-short">${shortText}</span>
                    <span class="see-more-ellipsis">... </span>
                    <span class="see-more-full" style="display:none;">${words.slice(limit).join(' ')}</span>
                </span>
                <span class="see-more-toggle">Ver mais</span>
            `;

            const toggle = el.querySelector('.see-more-toggle');
            const fullEl = el.querySelector('.see-more-full');
            const ellipsis = el.querySelector('.see-more-ellipsis');

            toggle.addEventListener('click', () => {
                const isExpanded = fullEl.style.display !== 'none';
                fullEl.style.display = isExpanded ? 'none' : 'inline';
                ellipsis.style.display = isExpanded ? 'inline' : 'none';
                toggle.textContent = isExpanded ? 'Ver mais' : 'Ver menos';
            });
        });
    }
}
document.addEventListener('DOMContentLoaded', () => {
    new SeeMore(15);
});
